module.exports = __webpack_public_path__ + "assets/jiangbei.710a10dc.svg";